
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="宣传图片">
              <a-input placeholder="请输入宣传图片" v-model="queryParam.spreadPic"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="宣传内容">
              <a-input placeholder="请输入宣传内容" v-model="queryParam.spreadContent"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('广告宣传')">导出</a-button>
      <a-upload
        name="file"
        :showUploadList="false"
        :multiple="false"
        :headers="tokenHeader"
        :action="importExcelUrl"
        @change="handleImportExcel"
      >
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete" />删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <template slot="spreadPic" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无图片</span>

          <div class="faImage">
            <a-popover trigger="hover" placement="right">
              <template slot="content">
                <img :src="getImgView(text)" alt="" style="width: 800px; height: 400px" class="hahImage" />
              </template>
              <img :src="getImgView(text)" alt="" style="width: 100%; height: 100%" class="hahImage" />
            </a-popover>
          </div>
          <!-- <img
            v-else
            :src="getImgView(text)"
            @click="showImgDialog(getImgView(text))"
            height="80px"
            alt
            style="max-width:80px;font-size: 12px;font-style: italic;"
          /> -->
        </template>

        <template slot="listingTime" slot-scope="text, record">
          <span>{{ record.listingDate + ' 到 ' + record.delistDate }}</span>
        </template>

        <template slot="areatime" slot-scope="text, record">
          <span>{{ record.startTime + ' 到 ' + record.endTime }}</span>
        </template>

        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无文件</span>
          <a-button v-else :ghost="true" type="primary" size="small" @click="preview(text)"> 预览视频 </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="shenHe(0,record)" v-if="record.auditingState != 1">审核&nbsp;&nbsp;</a>
          <a @click="shenHe(1,record)" v-else style="color:red">取消审核</a>&nbsp;&nbsp;
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <schoolSpread-modal ref="modalForm" @ok="modalFormOk"></schoolSpread-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import SchoolSpreadModal from './modules/SchoolSpreadModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { shenHeFunc } from '@/api/manage'

export default {
  name: 'SchoolSpreadList',
  mixins: [JeecgListMixin],
  components: {
    SchoolSpreadModal,
  },
  data() {
    return {
      description: '广告宣传管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '宣传图片',
          align: 'center',
          width: 200,
          dataIndex: 'spreadPic',
          scopedSlots: { customRender: 'spreadPic' },
        },
        {
          title: '宣传内容',
          align: 'center',
          dataIndex: 'spreadContent',
        },
        {
          title: '链接地址',
          align: 'center',
          dataIndex: 'spreadLink',
        },
        {
          title: '投放日期',
          align: 'center',
          dataIndex: 'listingTime',
          scopedSlots: { customRender: 'listingTime' },
        },
        {
          title: '投放时间段',
          align: 'center',
          dataIndex: 'areatime',
          scopedSlots: { customRender: 'areatime' },
        },
        {
          title: '审核状态',
          align: 'center',
          dataIndex: 'auditingState_dictText',
        },
        // {
        //   title: '点击量',
        //   align: 'center',
        //   dataIndex: 'clickAmount',
        // },
        // {
        //   title: '查看次数',
        //   align: 'center',
        //   dataIndex: 'checkFrequency',
        // },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/aigoes/schoolSpread/list',
        delete: '/aigoes/schoolSpread/delete',
        deleteBatch: '/aigoes/schoolSpread/deleteBatch',
        exportXlsUrl: 'aigoes/schoolSpread/exportXls',
        importExcelUrl: 'aigoes/schoolSpread/importExcel',
      },
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    shenHe(num,msg) {
      let temp = {
        id: msg.id,
        auditingState:  num == 0 ? 1 : 2,
      }
      shenHeFunc( '/aigoes/schoolSpread/examine', temp).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.message)
          this.modalFormOk()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    cancelshenHe(msg){

    }
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>